import { memo, useCallback, useEffect, useState } from 'react';
import cn from 'classnames';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';
import useSticky from '@zmedia/bm-soccer-ui/hooks/useSticky';
import {
    Container,
    Element,
    IconButton,
    Level,
    RouterLink,
} from '@zmedia/bm-soccer-ui/components';
import { URL_SOCCER_PAGE } from '@zmedia/bm-soccer-ui/modules/shared';
import Search from './search';
import UserProfile from './user';
import styles from './header.module.scss';
import { isMiniappSelector } from '@zmedia/bm-soccer-ui/selectors/app';

export function HeaderSoccer({ page }: { page: string }) {
    const [isSticky] = useSticky({ page });
    const router = useRouter();
    const [showSearch, setShowSearch] = useState<boolean>(false);
    const onClick = useCallback(() => {
        setShowSearch(!showSearch);
    }, [showSearch]);
    const isIframe = useSelector(isMiniappSelector);

    useEffect(() => {
        window.parent.postMessage(
            { type: 'FROM_BAOMOI', data: { loading: true } },
            'https://h5.zdn.vn'
        );
    }, []);

    return (
        <Element
            className={cn(styles['header-wrapper'], {
                [styles['is-sticky']]: isSticky,
                ['mt-[-50px]']: isIframe,
            })}
        >
            <Element
                renderAs="header"
                className={cn(styles['page-header'], {
                    hidden: isIframe,
                })}
            >
                <Container>
                    <Level>
                        <Level.Side align="left">
                            <Element
                                renderAs={
                                    router.asPath === '/bong-da.epi' ||
                                    router.asPath === '/soccer'
                                        ? 'h1'
                                        : 'div'
                                }
                            >
                                <Element
                                    renderAs="a"
                                    href={'/'}
                                    alt="Trang chủ"
                                    title="Trang chủ"
                                    className={styles['soccer-logo']}
                                    style={{
                                        backgroundImage: `url(https://baomoi-static.bmcdn.me/web/styles/img/bm-logo-v3.png)`,
                                    }}
                                />
                            </Element>
                            <Search showSearch={showSearch} />
                        </Level.Side>
                        <Level.Side align="right">
                            <Level.Item>
                                <RouterLink to={'/'} alt="home" title="Tin tức">
                                    Tin tức
                                </RouterLink>
                            </Level.Item>
                            <Level.Item>
                                <RouterLink
                                    to={URL_SOCCER_PAGE.LIVESCORE}
                                    alt="livescore"
                                    title="Livescore"
                                >
                                    Livescore
                                </RouterLink>
                            </Level.Item>
                            <Level.Item>
                                <UserProfile />
                            </Level.Item>
                            <Level.Item>
                                <IconButton
                                    icon={showSearch ? 'close-1' : 'search'}
                                    title={showSearch ? 'Đóng' : 'Tìm kiếm'}
                                    onClick={onClick}
                                />
                            </Level.Item>
                        </Level.Side>
                    </Level>
                </Container>
            </Element>
        </Element>
    );
}

export default memo(HeaderSoccer);
